module.exports = __webpack_public_path__ + "img/logo.eb6dc92f.svg";